"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StreamingConnectionApi = void 0;
var StreamingConnectionApi;
(function (StreamingConnectionApi) {
    StreamingConnectionApi["PRICING"] = "streaming/pricing/main";
    StreamingConnectionApi["QUANTITATIVE_ANALYTICS"] = "streaming/quantitative-analytics/financial-contracts";
    StreamingConnectionApi["BENCHMARK"] = "streaming/benchmark/resource";
    StreamingConnectionApi["CUSTOM_INSTRUMENTS"] = "streaming/custom-instruments/resource";
    StreamingConnectionApi["CUSTOM_INSTRUMENTS_NEW"] = "/data/custom-instruments/streaming-endpoints";
})(StreamingConnectionApi || (exports.StreamingConnectionApi = StreamingConnectionApi = {}));
